import { Button, Input } from '../../components';
import { Card, CardBody, CardFooter, CardTitle, Col, Form, FormGroup, Label, Row } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import { useFieldArray, useForm, Controller } from 'react-hook-form';

import Skeleton from 'react-loading-skeleton';
import { TabSetting } from '../../common/Types';
import { professionService } from '../../services/ProfessionAdministration';
import { toast } from 'react-toastify';

const ResourceTab = (props) => {
    const [resources, setResources] = useState<TabSetting[]>();
    const [editing, setEditing] = useState(false);
    const { control, handleSubmit, reset, setValue, getValues } = useForm();
    const { fields, append } = useFieldArray({
        control,
        name: 'resources',
    });

    const remove = (i) => {
        const current = getValues(`resources[${i}]`);
        (setValue as any)(`resources[${i}]`, { ...current, isActive: false });
        reset(getValues());
    };

    const toggleEdit = () => {
        setEditing(!editing);
        reset({ resources: resources });
    };

    const onSubmit = (formData) => {
        const toastId = toast.info('Saving information...');

        professionService
            .saveResources(
                props.coa.professionId,
                formData.resources.map((exp) => new TabSetting(exp)),
            )
            .then((response) => {
                toast.update(toastId, {
                    type: 'success',
                    render: 'Information Saved.',
                });
                toggleEdit();
                setResources(response);
            })
            .catch(() => {
                toast.update(toastId, {
                    type: 'error',
                    render: 'Failed to save information.',
                });
            });
    };

    useEffect(() => {
        const getResources = () => {
            professionService
                .getResources(props.coa.professionId)
                .then((response) => {
                    append(response);
                    setResources(response);
                })
                .catch(() => {
                    toast.error('Unable to get information.');
                });
        };

        getResources();
    }, [append, props.coa]);

    return (
        <>
            <Col md={6}>
                <Card>
                    <CardBody>
                        <CardTitle>
                            <h3>Resources Tab</h3>
                        </CardTitle>
                        {editing ? (
                            <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                                <FormGroup>
                                    <Label>Resources:</Label>
                                    {fields.map((expenditure, i) =>
                                        JSON.parse((expenditure as any).isActive) ? (
                                            <Card key={i}>
                                                <CardBody>
                                                    <div>
                                                        <FormGroup>
                                                            <Controller
                                                                name={`resources[${i}].title`}
                                                                control={control}
                                                                render={({ field }) => (
                                                                    <Input
                                                                        {...field}
                                                                        value={
                                                                            field.value ??
                                                                            (expenditure as any).title ??
                                                                            ''
                                                                        }
                                                                    />
                                                                )}
                                                            />
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <div className={'custom-control custom-checkbox'}>
                                                                <Controller
                                                                    name={`resources[${i}].requireDetail`}
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <Input
                                                                            type="checkbox"
                                                                            id={`resources[${i}].requireDetail`}
                                                                            {...field}
                                                                            checked={
                                                                                field.value ??
                                                                                JSON.parse(
                                                                                    (expenditure as any)
                                                                                        .requireDetail ?? 'false',
                                                                                )
                                                                            }
                                                                            className={'custom-control-input'}
                                                                        />
                                                                    )}
                                                                />
                                                                <Label
                                                                    for={`resources[${i}].requireDetail`}
                                                                    className={'custom-control-label'}
                                                                >
                                                                    Require detail of changes to resources?
                                                                </Label>
                                                            </div>
                                                        </FormGroup>
                                                        <Controller
                                                            name={`resources[${i}].professionId`}
                                                            control={control}
                                                            render={({ field }) => (
                                                                <input
                                                                    type="hidden"
                                                                    {...field}
                                                                    value={
                                                                        field.value ??
                                                                        (expenditure as any).professionId ??
                                                                        ''
                                                                    }
                                                                />
                                                            )}
                                                        />
                                                        <Controller
                                                            name={`resources[${i}].isActive`}
                                                            control={control}
                                                            render={({ field }) => (
                                                                <input
                                                                    type="hidden"
                                                                    {...field}
                                                                    value={
                                                                        field.value ??
                                                                        (expenditure as any).isActive ??
                                                                        ''
                                                                    }
                                                                />
                                                            )}
                                                        />
                                                        <Controller
                                                            name={`resources[${i}].customId`}
                                                            control={control}
                                                            render={({ field }) => (
                                                                <input
                                                                    type="hidden"
                                                                    {...field}
                                                                    value={
                                                                        field.value ??
                                                                        (expenditure as any).customId ??
                                                                        ''
                                                                    }
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </CardBody>
                                                <CardFooter className={'p-0'}>
                                                    <Button
                                                        className="remove"
                                                        color={'info'}
                                                        onClick={() => remove(i)}
                                                        type={'button'}
                                                    >
                                                        <i className={'mdi mdi-close'} />
                                                        <span className={'ml-1'}>Remove</span>
                                                    </Button>
                                                </CardFooter>
                                            </Card>
                                        ) : (
                                            <div key={i}>
                                                <Controller
                                                    name={`resources[${i}].title`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            type="hidden"
                                                            {...field}
                                                            value={field.value ?? (expenditure as any).title ?? ''}
                                                        />
                                                    )}
                                                />
                                                <Controller
                                                    name={`resources[${i}].professionId`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            type="hidden"
                                                            {...field}
                                                            value={
                                                                field.value ?? (expenditure as any).professionId ?? ''
                                                            }
                                                        />
                                                    )}
                                                />
                                                <Controller
                                                    name={`resources[${i}].isActive`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            type="hidden"
                                                            {...field}
                                                            value={field.value ?? (expenditure as any).isActive ?? ''}
                                                        />
                                                    )}
                                                />
                                                <Controller
                                                    name={`resources[${i}].customId`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            type="hidden"
                                                            {...field}
                                                            value={field.value ?? (expenditure as any).customId ?? ''}
                                                        />
                                                    )}
                                                />
                                                <Controller
                                                    name={`resources[${i}].requireDetail`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            type="hidden"
                                                            {...field}
                                                            value={
                                                                field.value ?? (expenditure as any).requireDetail ?? ''
                                                            }
                                                        />
                                                    )}
                                                />
                                            </div>
                                        ),
                                    )}
                                    <div>
                                        <Button
                                            className="add"
                                            color={'info'}
                                            onClick={() =>
                                                append({
                                                    professionId: props.coa.professionId,
                                                    customId: 0,
                                                    isActive: true,
                                                    title: '',
                                                    requireDetail: false,
                                                })
                                            }
                                        >
                                            <i className="remixicon-add-line" />
                                            <span className="ml-1">Add Resource</span>
                                        </Button>
                                    </div>
                                </FormGroup>
                                <Row className="mt-3">
                                    <Col>
                                        <Button type="submit">Save</Button>&nbsp;
                                        <Button outline onClick={() => toggleEdit()}>
                                            Cancel
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        ) : (
                            <>
                                <Label>Resources:</Label>
                                {resources ? (
                                    <>
                                        {resources.map((resource, i) => {
                                            return (
                                                <Row key={i}>
                                                    <Col className="resource-title">{resource.title}</Col>
                                                </Row>
                                            );
                                        })}
                                        <Row className="mt-3">
                                            <Col>
                                                <Button onClick={() => toggleEdit()}>Edit</Button>
                                            </Col>
                                        </Row>
                                    </>
                                ) : (
                                    <Skeleton count={5} />
                                )}
                            </>
                        )}
                    </CardBody>
                </Card>
            </Col>
        </>
    );
};

export default ResourceTab;
